"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quiz = void 0;
var Quiz = /** @class */ (function () {
    function Quiz(_words, _limit) {
        this._words = _words;
        this._limit = _limit;
        this.currentIndex = -1;
        this.shuffledWords = [];
        this.pickRandomWords();
    }
    Quiz.prototype.resetWords = function () {
        this.currentIndex = 0;
    };
    Quiz.prototype.nextWord = function () {
        this.currentIndex++;
    };
    Object.defineProperty(Quiz.prototype, "currentWord", {
        get: function () {
            return this.shuffledWords[this.currentIndex];
        },
        enumerable: false,
        configurable: true
    });
    Quiz.prototype.pickRandomWords = function () {
        var arr = this._words;
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * i);
            var temp = arr[i];
            arr[i] = arr[j];
            arr[j] = temp;
        }
        this.shuffledWords = arr;
    };
    return Quiz;
}());
exports.Quiz = Quiz;
